import { useTheme } from "../../hooks/useTheme";
import { capitalizeFirstLetter, productItemLabel } from "@markit/common.utils";
import { Colors } from "../../utils/colors";
import RectangleButton from "../Buttons/RectangleButton";
import { Icon } from "@iconify/react";
import { Event } from "@markit/common.types";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { DataLoaders } from "../../redux/slices/dataSlice";

type FullEventExistingTicketInfoProps = {
  totalUserTickets: number;
  event: Event;
  userId: string;
  numTicketsUserInGroups: number[];
};
export const FullEventExistingTicketInfo = (
  props: FullEventExistingTicketInfoProps
) => {
  const { totalUserTickets, event, userId, numTicketsUserInGroups } = props;
  const { theme } = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const itemLabel = useMemo(
    () => productItemLabel(event.eventType),
    [event.eventType]
  );

  const viewTickets = useCallback(() => {
    dispatch(DataLoaders.user(userId));
    navigate(`/e/${event.id}/i/${userId}`, {
      state: { eventId: event.id, userId: userId },
    });
  }, [dispatch, userId, navigate, event.id]);

  return (
    <div className="ColumnNormal" style={{ gap: 14 }}>
      <div className="AlignedRow" style={{ gap: 7, ...theme.PrimaryText }}>
        <Icon icon="ion:alert-circle" height={20} />
        <span className="NameAndNumber">
          You already have {itemLabel.plural}
        </span>
      </div>
      <div className="ColumnNormal" style={{ gap: 14 }}>
        <span style={{ ...theme.SubText, fontSize: 14 }}>
          You have{" "}
          <span style={{ color: Colors.BLUE5 }}>{`${totalUserTickets}`}</span>
          {` ${itemLabel.singular}${totalUserTickets > 1 ? "s" : ""} for this ${
            itemLabel.entity
          }.`}
        </span>
        <ul style={{ marginBlock: 0 }}>
          {event.customTickets.map((ticket, index) => {
            return numTicketsUserInGroups[index] > 0 ? (
              <li style={{ ...theme.SubText, fontSize: 14 }}>
                {`${capitalizeFirstLetter(ticket.label)}`}{" "}
                <span
                  style={{ color: Colors.BLUE5 }}
                >{`(${numTicketsUserInGroups[index]})`}</span>
              </li>
            ) : null;
          })}
        </ul>
        <RectangleButton
          buttonLabel={`View Your ${itemLabel.pluralCap}`}
          onPress={viewTickets}
          altPaddingVert={12}
          altTextColor={theme.PrimaryText.color}
          altColor={theme.NewPrimaryBG.backgroundColor}
          containerStyles={{
            border: `0.5px solid ${theme.EditableTextFieldBorder.borderColor}`,
          }}
          iconRight={
            <Icon
              icon="ion:arrow-forward"
              height={16}
              style={{
                color: theme.PrimaryText.color,
                transform: "rotateY(0deg) rotate(-45deg)",
              }}
            />
          }
        />
      </div>
    </div>
  );
};
